import { isArray } from '@dimjs/lang';
import { classNames } from '@dimjs/utils';
import { toArray } from '@flatbiz/utils';
import { cloneElement, Fragment } from 'react';
import { CommonPropsWithChildren, withNativeProps } from '../utils/native-props';
import './style.less';
export type PageProps = {
  isFixed?: boolean;
  flexFullIndex?: number | number[];
} & CommonPropsWithChildren;

export const Page = (props: PageProps) => {
  const flexFullIndexList = toArray<number>(props.flexFullIndex);
  const isFlex = flexFullIndexList.length > 0;
  const isFixed = isFlex ? true : props.isFixed;

  const className = classNames('v-page', { 'v-page-fixed': isFixed && !isFlex, 'v-page-flex': isFlex });

  const childrens = (isArray(props.children) ? props.children : [props.children]) as JSX.Element[];

  if (flexFullIndexList.length > 0) {
    return withNativeProps(
      props,
      <div className={className}>
        {childrens.map((children, index) => {
          if (flexFullIndexList.includes(index)) {
            const childrenStyle = children.props.style;
            return (
              <Fragment key={index}>
                {cloneElement(children, { style: { flex: 1, ...childrenStyle }, height: 'initial' })}
              </Fragment>
            );
          } else {
            return <Fragment key={index}>{children}</Fragment>;
          }
        })}
      </div>,
    );
  }
  return withNativeProps(props, <div className={className}>{props.children}</div>);
};
